import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/agents/id/prompt/page';

export const Route = createFileRoute('/_app/_chat/agents/$id/prompt/')({
  component: Page,
});
